import TableBody from './table-body';

export default TableBody;